import React, { useEffect, useState } from "react";
import {
  Button,
  Datagrid,
  DateField,
  FunctionField,
  ReferenceField,
  TextField,
  useDataProvider,
  useRecordContext,
  useRedirect,
} from "react-admin";
import { CYCLIC_SCHEDULE, DISCIPLINES, PROFESSORS, StudentServicePath } from "utils/constants";

import AddIcon from "@mui/icons-material/Add";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { administrationRequests } from "api/administrationApi";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";

const CyclicScheduleExpanded = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const redirect = useRedirect();
  const notifyError = useNotifyError();

  const [disciplines, setDisciplines] = useState([]);

  useEffect(() => {
    dataProvider
      .customRequest(studentRequests.getCyclicScheduleExpanded(record.id), null, "GET")
      .then(res => setDisciplines(res.data?.disciplines))
      .catch(notifyError);
  }, [record.id, dataProvider, notifyError]);

  return (
    <Datagrid
      data={disciplines}
      rowClick={false}
      bulkActionButtons={false}
      empty={<p>Няма налични специалности</p>}
    >
      <ReferenceField
        source="disciplineId"
        reference={administrationRequests.getDisciplinesSelect()}
        label="Дисциплина"
      >
        <TextField source="name" />
      </ReferenceField>
      <DateField
        source="classesStartDate"
        label="Начало на занятия"
        locales="bg-BG"
      />
      <DateField
        source="classesEndDate"
        label="Край на занятия"
        locales="bg-BG"
      />
      <DateField
        source="examsStartDate"
        label="Начало на сесия"
        emptyText="-"
        locales="bg-BG"
      />
      <DateField
        source="examsEndDate"
        label="Край на сесия"
        emptyText="-"
        locales="bg-BG"
      />
      <SecuredComponent permission={permissions.canUpdateCyclicSchedulesProfessors}>
        <FunctionField
          label=""
          textAlign="center"
          render={rec => (
            <Button
              onClick={() =>
                redirect(`/${StudentServicePath}${CYCLIC_SCHEDULE}/${DISCIPLINES}/${rec.id}/${PROFESSORS}`)
              }
              size="small"
              variant="contained"
              label="Преподавател"
              color="secondary"
            >
              <AddIcon />
            </Button>
          )}
        />
      </SecuredComponent>
    </Datagrid>
  );
};

export default CyclicScheduleExpanded;
